<template>
    <div id="legend">
        <svg width="450" height="75" id="legend-image" viewBox="0 0 450 75">
            <text class="legendtitle" x="50%" y="18px">
                {{ legendTitle }}
            </text>
            <rect x="15" y="25" width="420" height="10" id="legend-scale" />
            <g id="legend-xaxis" :transform="`translate(15, 35)`">
                <g
                    class="tick"
                    v-for="(tick, index) in xTicks"
                    :key="index"
                    :transform="`translate(${xScale(tick)},0)`"
                >
                    <line stroke="currentColor" y2="-10"></line>
                    <text
                        x="0"
                        y="15"
                        v-if="index != Object.keys(xTicks).length - 1"
                    >
                        {{ tick }}
                    </text>
                    <text x="0" y="15" id="lastitem" v-else>
                        &gt; {{ tick }}
                    </text>
                </g>
            </g>
            <text x="50%" y="65px">
                {{ legendSubTitle }}
            </text>
            <defs>
                <linearGradient id="gradient-fill">
                    <stop
                        v-for="(value, index) in classBoundaries"
                        :key="value"
                        :offset="gradientScale(value)"
                        :stop-color="legendColours[index]"
                    />
                </linearGradient>
            </defs>
        </svg>
    </div>
</template>
<script>
import d3 from "@/assets/d3";

export default {
    name: "LegendBlock",
    props: {
        classBoundaries: {
            default: function () {
                return [0, 1, 2];
            },
            type: Array,
        },
        legendColours: {
            default: function () {
                return ["#000", "#666", "#fff"];
            },
            type: Array,
        },
        legendSubTitle: {
            default: "Omschrijving",
            type: String,
        },
        legendTitle: {
            default: "Legenda",
            type: String,
        },
    },
    methods: {
        formatDutch(d) {
            return new Intl.NumberFormat("nl-NL").format(d);
        },
    },
    computed: {
        gradientScale() {
            return d3
                .scaleLinear()
                .domain(d3.extent(this.classBoundaries))
                .range([0, 1])
                .nice();
        },
        xScale() {
            return d3
                .scaleLinear()
                .domain(d3.extent(this.classBoundaries))
                .range([0, 420])
                .nice();
        },
        xTicks() {
            return this.xScale.ticks(5, this.formatDutch);
        },
    },
};
</script>
<style scoped>
#legend {
    padding: 5px;
    position: fixed;
    bottom: 80px;
    left: 10px;
    z-index: 5;
    width: 500px;
    background-color: rgba(255, 255, 255);
    box-shadow: 0px 4px 6px rgba(0, 35, 40, 0.2);
    display: inline-flex;
    justify-content: center;
    font-weight: 300;
    border-radius: 4px;
}

.legendtitle {
    font-size: 16px;
    font-weight: bold;
}

#legend-scale {
    fill: url(#gradient-fill);
    filter: drop-shadow(2px 2px 2px rgb(0 35 40 / 0.4));
}

.tick {
    opacity: 1;
    color: #fff;
}

.tick text {
    font-size: 12px;
}

text {
    font-size: 14px;
    color: #000;
    text-anchor: middle;
}

#lastitem {
    text-anchor: end;
}

path.domain {
    stroke: #fff;
}

@media (max-width: 750px) {
    #legend {
        padding: 5px 3px;
        bottom: calc(70px + 3vw);
        left: 3vw;
        width: 94vw;
    }
}
</style>
